import { render } from "./AddNewCardModal.vue?vue&type=template&id=f159a9f0&ts=true"
import script from "./AddNewCardModal.vue?vue&type=script&lang=ts"
export * from "./AddNewCardModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__